import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { FALLBACK_CONTENT } from "@/lib/data";

const SECTIONS = [
  ["What we collect", "When you book a clean, request a quote or contact us, we collect your name, phone number, email address, property address and any notes you choose to share. We collect only what we need to arrange and carry out your clean."],
  ["How we use it", "Your details are used solely to respond to your enquiry, confirm and manage your booking, and contact you about your appointment. We do not sell or share your personal data with third parties for marketing."],
  ["Cookies", "This site uses essential cookies to function and, with your consent, optional analytics cookies. You can accept or decline analytics via the cookie banner, and change your choice at any time by clearing your browser storage."],
  ["How long we keep it", "Booking and enquiry records are kept for as long as needed to manage your job and meet our legal and accounting obligations, then securely deleted."],
  ["Your rights", "Under UK GDPR you can request a copy of your data, ask us to correct it, or ask us to delete it at any time. Email us and we will respond within 30 days."],
  ["Contact", "SY Exterior Cleaning, South Yorkshire, United Kingdom. Email: mitchellsgutterservices@gmail.com · Phone: 07378114330."],
];

export default function PrivacyPage() {
  return (
    <div className="bg-[#070b12] min-h-screen text-[#f0f4f8]" data-testid="privacy-page">
      <header className="border-b border-[#1e9bff]/20 py-5">
        <div className="max-w-4xl mx-auto px-4">
          <Link to="/"><Logo /></Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-16">
        <h1 className="font-display uppercase text-4xl text-white mb-2" data-testid="privacy-heading">Privacy Policy</h1>
        <p className="text-xs font-mono-lbl text-[#93b4d4] mb-10 uppercase tracking-widest">SY Exterior Cleaning · UK GDPR</p>
        <div className="space-y-8">
          {SECTIONS.map(([title, body], i) => (
            <section key={title} data-testid={`privacy-section-${i}`}>
              <h2 className="font-display uppercase text-xl text-[#1e9bff] mb-2">{title}</h2>
              <p className="text-sm text-[#c8d9ea] leading-relaxed">{body}</p>
            </section>
          ))}
        </div>
        <Link to="/" data-testid="privacy-home-link" className="inline-block mt-12 text-[#1e9bff] font-mono-lbl text-xs uppercase tracking-widest hover:underline">
          ← Back to homepage
        </Link>
      </main>
    </div>
  );
}
